// extracted by mini-css-extract-plugin
export var numpadContainer = "_la-1";
export var phoneButton = "_la-0";